import { Api } from "../config/request";

export default {
  getPrizeItemList(payload) {
    return Api.post("/prize-items/list", payload);
  },
  getPrizeItem(payload) {
    return Api.post("/prize-items/detail", payload);
  },
  updatePrizeItem(payload) {
    return Api.post("/prize-items/update", payload);
  },
};
